// extracted by mini-css-extract-plugin
module.exports = {"label":"datafilterdaterangebox_label__27j_t","btnCalendar":"datafilterdaterangebox_btnCalendar__1i717","calendarBox":"datafilterdaterangebox_calendarBox__1HmNt"};